import * as React from 'react';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertColor, AlertProps } from '@mui/material/Alert';
import { AppContext, AppContextPropTypes } from '../../context/AppContext';

export interface BakeasySnackbarProps {
  snackbar: BakeasySnackbarProp;
}

export interface BakeasySnackbarProp {
  open?: boolean;
  message?: string;
  severity?: AlertColor;
  handleOnClose?: (event: React.SyntheticEvent | Event) => void;
}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function BakeasySnackbar(props: BakeasySnackbarProps) {
  let myContext = React.useContext(AppContext);
  function handleOnClose() {
    myContext.setSnackbar({ open: false });
  }
  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      {props?.snackbar.open && (
        <Snackbar
          open={props?.snackbar.open ? props?.snackbar.open : false}
          autoHideDuration={2000}
          onClose={handleOnClose}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert
            onClose={handleOnClose}
            severity={props?.snackbar?.severity}
            sx={{ width: '100%' }}
          >
            {props?.snackbar?.message}
          </Alert>
        </Snackbar>
      )}
    </Stack>
  );
}

export function ShowSnackbarSuccess(response: any, myContext: AppContextPropTypes) {
  let message = '';
  if (response?.data?.data?.message) {
    message = JSON.stringify(response?.data?.data?.message);
  } else if (response?.data?.message) {
    message = JSON.stringify(response?.data?.message);
  } else if (response?.data) {
    message = JSON.stringify(response?.data);
  } else {
    message = response;
  }

  myContext.setSnackbar({ open: true, severity: 'success', message: message });
}

export function ShowSnackbarFailure(err: any, myContext: AppContextPropTypes) {
  let message = '';
  if (err?.response?.data?.error) {
    message = JSON.stringify(err?.response?.data?.error);
  } else if (err?.response?.data) {
    message = JSON.stringify(err?.response?.data);
  } else if (err?.data) {
    message = JSON.stringify(err?.data);
  } else if (err?.message) {
    message = JSON.stringify(err?.message);
  } else if (err?.error) {
    message = err?.error;
  } else {
    message = err;
  }

  myContext.setSnackbar({ open: true, severity: 'error', message: message });
}

export default BakeasySnackbar;
